export default "__VITE_ASSET__DLQ9lACn__"